import React from "react";
import { Routes, Route, Link, useLocation, Navigate } from "react-router-dom";

// Import the individual tab components
import AccountSettings from "./account/AccountSettings";
import TimezoneSettings from "./account/TimezoneSettings";
import IntegrationsSettings from "./account/IntegrationsSettings";
import ApiSettings from "./account/ApiSettings";

interface AccountTabsProps {
  user: {
    id: string;
    username: string;
    displayName?: string;
    display_name?: string;
    profileImageUrl?: string;
    profile_image_url?: string;
    userType: "user" | "premium" | "vip" | "admin";
    email?: string;
    timezone?: string;
    approved?: boolean;
  };
  authToken: string;
}

const AccountTabs: React.FC<AccountTabsProps> = ({ user, authToken }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    {
      id: "account",
      label: "Account",
      path: "/dashboard/account",
    },
    {
      id: "timezone",
      label: "Timezone Settings",
      path: "/dashboard/account/timezone",
    },
    {
      id: "integrations",
      label: "Integrations",
      path: "/dashboard/account/integrations",
    },
    { id: "api", label: "API", path: "/dashboard/account/api" },
  ];

  return (
    <div>
      {/* Tab Navigation */}
      <div
        style={{
          display: "flex",
          gap: "24px",
          marginBottom: "24px",
          borderBottom: "1px solid #4a5568",
        }}
      >
        {tabs.map((tab) => {
          const isActive = currentPath === tab.path;
          return (
            <Link
              key={tab.id}
              to={tab.path}
              style={{
                padding: "12px 0",
                color: isActive ? "#9146FF" : "#cbd5e0",
                textDecoration: "none",
                borderBottom: isActive
                  ? "2px solid #9146FF"
                  : "2px solid transparent",
                fontWeight: isActive ? "bold" : "normal",
                transition: "all 0.2s",
                marginBottom: "-1px",
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = "#e2e8f0";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = "#cbd5e0";
                }
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>

      {/* Tab Content */}
      <Routes>
        <Route
          path="/"
          element={<AccountSettings user={user} authToken={authToken} />}
        />
        <Route
          path="timezone"
          element={<TimezoneSettings user={user} authToken={authToken} />}
        />
        <Route
          path="integrations"
          element={<IntegrationsSettings user={user} authToken={authToken} />}
        />
        <Route
          path="api"
          element={<ApiSettings user={user} authToken={authToken} />}
        />
      </Routes>
    </div>
  );
};

export default AccountTabs;
